import React, { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import api, { apiErr } from "@/lib/api";
import { toast } from "@/components/ui/sonner";
import { CheckSquare, X, Loader2 } from "lucide-react";

const sel = "rounded-lg border border-white/30 bg-white/10 text-white px-2 py-1.5 text-xs outline-none [&>option]:text-black";

export const BiddingBulkBar = ({ ids, vendors, onClear }) => {
  const qc = useQueryClient();
  const [addV, setAddV] = useState("");
  const [remV, setRemV] = useState("");
  const [prefV, setPrefV] = useState("");
  const m = useMutation({ mutationFn: async (body) => (await api.post("/procurement/bidding/bulk", { item_ids: ids, ...body })).data,
    onSuccess: (d) => { qc.invalidateQueries({ queryKey: ["bidding"] }); toast.success(`Ενημερώθηκαν ${d.updated} είδη`); setAddV(""); setRemV(""); setPrefV(""); }, onError: (e) => toast.error(apiErr(e)) });
  const b = "rounded-lg border border-white/30 px-3 py-1.5 text-xs font-semibold hover:bg-white/10 disabled:opacity-40";
  return (
    <div className="sticky top-2 z-20 rounded-2xl bg-[#45423C] text-white shadow-xl px-4 py-3 flex flex-wrap items-center gap-2" data-testid="bid-bulk-bar">
      <CheckSquare className="h-4 w-4 text-[#E3B23C]" />
      <span className="text-sm"><strong className="tabular">{ids.length}</strong> επιλεγμένα</span>
      <span className="mx-1 h-5 w-px bg-white/20" />
      <button data-testid="bid-bulk-offer-off" disabled={m.isPending} onClick={() => m.mutate({ needs_offer: false })} className={b}>Χωρίς προσφορά</button>
      <button data-testid="bid-bulk-offer-on" disabled={m.isPending} onClick={() => m.mutate({ needs_offer: true })} className={b}>Ζητά προσφορά</button>
      <span className="mx-1 h-5 w-px bg-white/20" />
      <select data-testid="bid-bulk-add-vendor" className={sel} value={addV} onChange={(e) => { setAddV(e.target.value); if (e.target.value) m.mutate({ add_vendor_ids: [e.target.value] }); }}>
        <option value="">+ Προσθήκη προμηθευτή…</option>{vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
      </select>
      <select data-testid="bid-bulk-remove-vendor" className={sel} value={remV} onChange={(e) => { setRemV(e.target.value); if (e.target.value) m.mutate({ remove_vendor_ids: [e.target.value] }); }}>
        <option value="">− Αφαίρεση προμηθευτή…</option>{vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
      </select>
      <select data-testid="bid-bulk-preferred-vendor" className={sel} value={prefV} onChange={(e) => { setPrefV(e.target.value); if (e.target.value) m.mutate({ preferred_vendor_id: e.target.value === "__none" ? "" : e.target.value }); }}>
        <option value="">★ Προτιμώμενος προμηθευτής…</option><option value="__none">— κανένας —</option>{vendors.map((v) => <option key={v.id} value={v.id}>{v.name}</option>)}
      </select>
      {m.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
      <button data-testid="bid-bulk-clear" onClick={onClear} className="ml-auto p-1.5 rounded-lg hover:bg-white/10" title="Καθαρισμός επιλογής"><X className="h-4 w-4" /></button>
    </div>
  );
};
